import axios from "axios";
import { BASEPATH } from "./constant";

const instance = axios.create({
  baseURL: BASEPATH,
});
export default instance;
